var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['image'],style:({
    width: ((_vm.props.imageWidth / 50) + "rem"),
    height: ((_vm.props.imageWidth / 50) + "rem")
  })},[_c(_vm.injections.components.GoodImage,{tag:"component",attrs:{"img-url":_vm._f("ossHttpVersion")(_vm.props.imgUrl),"width":((_vm.props.imageWidth / 50) + "rem"),"height":((_vm.props.imageWidth / 50) + "rem"),"mode":'cover'}}),(_vm.props.isVideo)?_c('img',{staticClass:"video-pic",attrs:{"src":require("../../../../src/images/cms/goods/play.png")}}):_vm._e(),_vm._l((_vm.props.promoteTagPic),function(pic,index){return _c('img',{key:index,staticClass:"promote-tag-pic",attrs:{"src":pic}})}),_c('div',{class:_vm.props.stockStatus ? 'mask' : '',style:({
      width: ((_vm.props.imageWidth / 50) + "rem"),
      height: ((_vm.props.imageWidth / 50) + "rem")
    })},[(_vm.props.stockStatus)?_c('div',{class:['goods-status', _vm.props.type]},[_c('div',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.props.stockStatus))])]):_vm._e()]),(_vm.props.sortIndex != 0)?_c('div',{class:[
      'sort-image',
      _vm.props.sortIndex > 0 && _vm.props.sortIndex <= 3
        ? 'sort-image-number-' + _vm.props.sortIndex
        : ''
    ]},[_vm._v(" "+_vm._s(_vm.props.sortIndex)+" "),_c('div',{class:[
        'triangle',
        _vm.props.sortIndex > 0 && _vm.props.sortIndex <= 3
          ? 'triangle-number-' + _vm.props.sortIndex
          : ''
      ]})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }